module.exports = __webpack_public_path__ + "static/media/3_Heaven and hell_FA .1d6f7aee.txt";